module.exports = " <div class=\"row gris-base\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/teaching/subjects/list/index.html
// module id = 577
// module chunks = 0